const dashboard = {
  collectedToday: 'Collectés aujourd\'hui',
  declinedPayments: 'Paiements refusés',
  unpaidDonations: 'Factures impayées',
  scheduled: 'Prévus',
  events: 'Événements',
  payments: 'paiements',
  paymentsToReview: 'paiements à réviser',
  pledges: 'promesses',
  paymentsToCome: 'paiements à venir ce mois-ci',
  activeCampaigns: 'campagnes actives',
  versusYesterday: 'vs hier',
  oldestDays: 'plus ancien',
  days: 'jours',
  donor: 'Donateur',
  payment: 'ID Paiement',
  date: 'Date',
  reason: 'Raison',
  amount: 'Montant',
  actions: 'Actions',
  edit: 'Modifier',
  retry: 'Réessayer',
  downloadCsv: 'Télécharger CSV',
  dueDate: 'Échéance',
  endDate: 'Date de fin',
  daysOverdue: 'Jours de retard',
  sendInvoice: 'Envoyer facture',
  downloadInvoice: 'Télécharger PDF',
  sendTaxReceipt: 'Envoyer reçu fiscal',
  downloadTaxReceipt: 'Télécharger reçu fiscal',
  scheduledPayments: 'Paiements prévus',
  scheduledDate: 'Date prévue',
  paymentMethod: 'Méthode de paiement',
  periodAll: 'Tout',
  periodToday: 'Aujourd\'hui',
  periodLastWeek: 'La semaine dernière',
  periodLastMonth: 'Le mois dernier',
  periodThisWeek: 'Cette semaine',
  periodMonth: 'Ce mois-ci',
  periodTomorrow: 'Demain',
  fundraisingEvents: 'Collecte de fonds',
  goal: 'Objectif',
  eventsCount: 'événements',
  eventPage: 'Page',
  of: 'de',
  recentPayments: 'Paiements récents',
  topDonors: 'Meilleurs donateurs cette année',
  gifts: 'dons',
  filter: 'Filtrer par nom, compagnie ou titre…',
};

export default dashboard;
